import { SelectInput as RaSelectInput } from 'react-admin';
import { styled } from '@mui/material';

const SelectInput = styled(RaSelectInput)({
  minWidth: '14.5rem',
});

export default SelectInput;
